import { Language, Location } from '@nx-smartmonkey/shared/domain';
import { Organization } from '../domain/organization/Organization';
import { Project } from '../domain/project/Project';
import { User } from '../domain/user/User';
import { onboardingRepository } from '../repositories/onboarding';
import {
  CreateOrganizationOnboardingResponse,
  OnboardingRepository,
} from '../repositories/onboarding/OnboardingRepository';
import eventsPanel from '../services/events';
import { intercom } from '../services/intercom';

export class OnboardingService {
  constructor(private onboardingRepository: OnboardingRepository) {}

  async initializeOnboarding(plan_name?: string): Promise<CreateOrganizationOnboardingResponse> {
    return this.onboardingRepository.initializeOnboarding(plan_name);
  }

  async updateOrganization({
    user,
    language,
    organization,
  }: {
    user: User;
    language: Language;
    organization: Organization;
  }): Promise<Organization> {
    const updatedOrganization = await this.onboardingRepository.updateOrganization(organization);

    eventsPanel.onboardingDone({
      firstName: user.first_name,
      lastName: user.last_name,
      country: updatedOrganization.country,
      email: user.email,
      phone: user.phone,
      organizationName: updatedOrganization.label,
      organizationId: updatedOrganization.id,
      ownerId: updatedOrganization.owner_id,
      createdAt: updatedOrganization.created_at,
      language: language.value,
      numOfVehicles: updatedOrganization.num_of_vehicles,
      goal: updatedOrganization.goal,
      section: updatedOrganization.section,
    });

    intercom.setUser({
      company: {
        created_at: updatedOrganization.created_at,
        company_id: updatedOrganization.id,
        name: updatedOrganization.label,
        status: updatedOrganization.subscription.status,
        plan: updatedOrganization.subscription.plan,
        vehicles: updatedOrganization.subscription.vehicles,
      },
      numOfVehicles: updatedOrganization.num_of_vehicles,
      goal: updatedOrganization.goal,
      section: updatedOrganization.section,
      user_hash: user.intercom_hash,
    });

    return updatedOrganization;
  }

  async updateProject(project: Project): Promise<Project> {
    return this.onboardingRepository.updateProject(project);
  }

  async updateOnboardingLocation(location: Location): Promise<void> {
    return this.onboardingRepository.updateOnboardingLocation(location);
  }

  async finalizeOnboarding(): Promise<void> {
    return this.onboardingRepository.finalizeOnboarding();
  }
}

export const onboardingService = new OnboardingService(onboardingRepository);
